/**
 * Main fetcher for the library and images list.
 *
 * @param query GraphQL query
 * @param variables variables to pass to the query such as organizationId or libraryId
 * @param settings API keys and other settings
 * @returns Stringified JSON data
 */
export const fetcher = async (
  query: string,
  variables: Record<string, string | number | string[]>,
  settings?: Settings | null,
) => {
  if (!settings) return null

  const body = {
    query,
    operationName: 'Query',
    variables,
  }

  const results = await fetch('https://api.raster.app', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: typeof settings.apiKey === 'string' ? `Bearer ${settings.apiKey}` : '',
      'Apollo-Require-Preflight': 'true',
    },

    body: JSON.stringify(body),
  })

  const data = await results.json()
  return data.data
}

/**
 * SWR fetcher for the library list.
 * @param key
 * @returns return library list
 */
export const swrLibrariesFetcher = ({ query, variables, settings }: Fetcher): Promise<Library[]> =>
  fetcher(query, variables, settings).then((res) => {
    const libraryList = res.libraries.map((library: Library) => ({
      id: library.id,
      name: library.name,
      imagesCount: library.imagesCount || library.photosCount,
    }))

    return libraryList as Library[]
  })

/**
 * SWR fetcher for the image list.
 * @param key
 * @returns the list of images
 */
export const swrImagesFetcher = ({ query, variables, settings }: Fetcher): Promise<Image[]> =>
  fetcher(query, variables, settings).then((res) => (res.assets || []) as Image[])
